/**
 * @auth 赖传峰
 * @date 2022/6/14
 */
import {
  defineNuxtRouteMiddleware,
  navigateTo,
} from '#imports'
import { RoutePath } from '~/types/enum'
import isMobileInServerAndClient from '~/utils/isMobileInServerAndClient'

export default defineNuxtRouteMiddleware(async to => {
  const isExtensionPage = to.path.includes(RoutePath.BROWSER_EXTENSION)
  if ((isMobileInServerAndClient()) && isExtensionPage) {
    return navigateTo(to.path.replace(RoutePath.BROWSER_EXTENSION, ''))
  }
})
